import { Link, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function ConfigurationLayout() {
  const { t } = useTranslation('navigation');

  return (
    <div className='grid items-start gap-6 md:grid-cols-[12rem_minmax(0,1fr)]'>
      <nav
        aria-label={t('Configuration')}
        className='rounded-lg border bg-background p-2'
      >
        <Link
          activeProps={{ className: 'bg-accent text-accent-foreground' }}
          className='block rounded-md px-3 py-2 font-medium text-sm hover:bg-accent/60'
          to='/configuration/country-risks'
        >
          {t('CountryRisks')}
        </Link>
      </nav>
      <div className='min-w-0 rounded-lg border bg-background'>
        <Outlet />
      </div>
    </div>
  );
}
